<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                          <span  v-html="message"></span>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                              {{ buttonText }}
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "InfoModal",
    props: {
        message: String,
        buttonText: String,
    }
}
</script>



// WEBPACK FOOTER //
// InfoModal.vue?2e8a8feb